import React, { createContext, useContext, useState, useEffect } from "react";
import { translations } from "../lib/i18n";

const LanguageContext = createContext(null);

const SEO_META = {
  de: {
    title: "Car Detailing Wien | Autoaufbereitung – Hetlav Detailing",
    description:
      "Hetlav Detailing Wien: professionelle Autoaufbereitung & Fahrzeugaufbereitung. Mobile Innenreinigung fürs Auto in ganz Wien – Termin nach Vereinbarung.",
    ogLocale: "de_AT",
    htmlLang: "de",
  },
  ua: {
    title: "Хімчистка авто Відень | Auto Detailing – Hetlav Detailing",
    description:
      "Hetlav Detailing у Відні: професійна хімчистка та аубереітунг салону авто. Мобільний детейлінг по всьому Відню — за попереднім записом.",
    ogLocale: "uk_UA",
    htmlLang: "uk",
  },
};

const setMeta = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {

      const url = new URL(window.location.href);
      const q = url.searchParams.get("lang");
      if (q === "ua" || q === "uk") return "ua";
      if (q === "de") return "de";
      return localStorage.getItem("hd_lang") || "de";
    } catch {
      return "de";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("hd_lang", lang);
    } catch {}
    const meta = SEO_META[lang] || SEO_META.de;
    document.documentElement.lang = meta.htmlLang;
    document.title = meta.title;
    setMeta('meta[name="description"]', "content", meta.description);
    setMeta('meta[property="og:title"]', "content", meta.title);
    setMeta('meta[property="og:description"]', "content", meta.description);
    setMeta('meta[property="og:locale"]', "content", meta.ogLocale);
    setMeta('meta[name="twitter:title"]', "content", meta.title);
    setMeta('meta[name="twitter:description"]', "content", meta.description);
  }, [lang]);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be within LanguageProvider");
  return ctx;
};
